export enum EmailTemplateContextKeys {
  agent = 'agent',
  registrant = 'registrant',
  guests = 'guests',
  conference = 'conference',
  transactions = 'transactions',
}

export const EmailTemplateContextMap: Map<EmailTemplateContextKeys, string> = new Map([
  [EmailTemplateContextKeys.agent, 'Agent'],
  [EmailTemplateContextKeys.registrant, 'Registrant'],
  [EmailTemplateContextKeys.guests, 'Guests'],
  [EmailTemplateContextKeys.conference, 'Conference'],
  [EmailTemplateContextKeys.transactions, 'Transactions'],
]);

export enum EmailTemplateAgentKeys {
  first_name = 'first_name',
  last_name = 'last_name',
  p_email = 'p_email',
  shipping_address = 'shipping_address',
  billing_address = 'billing_address',
  phone_number = 'phone_number',
  mga = 'mga',
  agency = 'agency',
  title = 'title',
  suffix = 'suffix',
  prefix = 'prefix',
  agent_id = 'agent_id',
}

export enum EmailTemplateConferenceKeys {
  event_name = 'event_name',
  start_date = 'start_date',
  end_date = 'end_date',
  registration_start_date = 'registration_start_date',
  registration_end_date = 'registration_end_date',
  facility_name = 'facility_name',
  event_coordinator_first_name = 'event_coordinator_first_name',
  event_coordinator_last_name = 'event_coordinator_last_name',
  event_coordinator_phone = 'event_coordinator_phone',
  event_coordinator_email = 'event_coordinator_email',
  welcomeTitle = 'welcomeTitle',
  welcomeDescription = 'welcomeDescription',
  welcomeImagePath = 'welcomeImagePath',
  hotel_name = 'hotel_name',
  hotel_state = 'hotel_state',
  hotelRegion = 'hotelRegion',
  hotel_address = 'hotel_address',
  hotel_coordinator_first_name = 'hotel_coordinator_first_name',
  hotel_coordinator_last_name = 'hotel_coordinator_last_name',
  hotel_coordinator_email = 'hotel_coordinator_email',
  hotel_primary_phone = 'hotel_primary_phone',
  hotel_room_rate = 'hotel_room_rate',
  hotel_num_rooms_blocked = 'hotel_num_rooms_blocked',
}

export enum EmailTemplateRegistrantKeys {
  first_name = 'first_name',
  last_name = 'last_name',
  id_first_name = 'id_first_name',
  id_last_name = 'id_last_name',
  passport_first_name = 'passport_first_name',
  passport_last_name = 'passport_last_name',
  email = 'email',
  invitee_email = 'invitee_email',
  phone = 'phone',
  suffix = 'suffix',
  prefix = 'prefix',
  badge_name = 'badge_name',
  award_name = 'award_name',
  first_time_attendee = 'first_time_attendee',
  gender = 'gender',
  dob = 'dob',
  shipping_address = 'shipping_address',
  billing_address = 'billing_address',
  hasDietaryConsideration = 'hasDietaryConsideration',
  emergency_contact_first_name = 'emergency_contact_first_name',
  emergency_contact_last_name = 'emergency_contact_last_name',
  emergency_contact_email = 'emergency_contact_email',
  emergency_contact_phone = 'emergency_contact_phone',
  emergency_contact_relationship = 'emergency_contact_relationship',
  emergency_contact_address = 'emergency_contact_address',
  checkInDate = 'checkInDate',
  checkOutDate = 'checkOutDate',
  requestedCheckInDate = 'requestedCheckInDate',
  requestedCheckOutDate = 'requestedCheckOutDate',
  hasDifferBookingDatesRequest = 'hasDifferBookingDatesRequest',
  hasDifferTravelDatesRequest = 'hasDifferTravelDatesRequest',
  travelDates = 'travelDates',
  travelArrivalDate = 'travelArrivalDate',
  travelDepartureDate = 'travelDepartureDate',
  hotelCheckInDate = 'hotelCheckInDate',
  hotelCheckOutDate = 'hotelCheckOutDate',
  hasAdditionalRoomRequest = 'hasAdditionalRoomRequest',
  chairmanCheckInDate = 'chairmanCheckInDate',
  chairmanCheckOutDate = 'chairmanCheckOutDate',
}
